import { combineReducers } from "redux";
import authReducer from "features/auth/reducer";
import ctdDataTools from "features/datatools/reducer";
import elabReducer from "features/elab/upload/reducer";
import workareaReducer from "features/workarea/reducer";
import organizationReducer from "features/organization/reducer";
import ctdReducer from "features/ctd/reducer";
import soloReducer from "features/solo/reducer";
import uiReducer from "./ui/reducer";
import reducer from "./sitedata/reducer";
import soloLookupReducer from "./soloLookup/reducer";

const reducers = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  workarea: workareaReducer,
  organization: organizationReducer,
  ctd: ctdReducer,
  solo: soloReducer,
  datatools: ctdDataTools,
  elab: elabReducer,
  siteData: reducer,
  soloUIDLookup: soloLookupReducer
});

export default reducers;
